import { InviteStatus } from '../../../constants/invite'
import { AdminRoles } from '../../../constants/roles'
import { objectToQueryString } from '../../../utils/objectToQueryString'
import { ecbrRequest } from '../../request/ecbrRequest'

export const userInvites = {
  getAll: async (params) => ecbrRequest.get('/user-invites', { params }),
  getById: async (id) => ecbrRequest.get(`/user-invites/${id}`),
  getPendingInvites: async (params) =>
    ecbrRequest.get('/user-invites', {
      params: { ...params, status: InviteStatus.PENDING }
    }),
  getAcceptedInvites: async (params) =>
    ecbrRequest.get('/user-invites', {
      params: { ...params, status: InviteStatus.ACCEPTED }
    }),
  getPendingAdminInvites: async (params) =>
    ecbrRequest.get(
      `/user-invites${objectToQueryString({
        ...params,
        roles: AdminRoles
      })}`
    ),
  invite: async (data) => ecbrRequest.post('/user-invites', data),
  reinvite: async (id) => ecbrRequest.post(`/user-invites/reinvite/${id}`),
  completeRegistration: async (hash, data) =>
    ecbrRequest.post(`/user-invites/accept/${hash}`, data),
  delete: async (id) => ecbrRequest.delete(`/user-invites/${id}`),
  update: async (id, data) => ecbrRequest.put(`/user-invites/${id}`, data)
}
